<template>
  <div>
    <vx-card ref="filterCard" class="user-list-filters mb-8">
      <div class="vx-row">
        <vs-button
          class="ml-5"
          icon-pack="feather"
          icon="icon-plus"
          @click="AddNew"
          >Add</vs-button
        >
        <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
          <vs-table
            pagination
            search
            max-items="20"
            :data="data"
            :stripe="true"
            v-if="data != null"
            v-model="selected"
            @selected="editData(selected)"
          >
            <template slot="thead">
              <vs-th sort-key="userName">User name</vs-th>
              <vs-th sort-key="fullName">Full Name</vs-th>
              <vs-th sort-key="departmentName">Department Name</vs-th>
              <vs-th sort-key="role">Role</vs-th>
              <vs-th sort-key="procurementDeptId">Procurement Department</vs-th>
              <vs-th sort-key="isVendorAdmin">Approve Vendor</vs-th>
              <vs-th sort-key="isProjectAdmin">Approve Project</vs-th>
              <vs-th sort-key="status">Status</vs-th>
              <vs-th sort-key="action">Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].userName">
                  {{ data[indextr].userName }}
                </vs-td>
                <vs-td :data="data[indextr].fullName">
                  {{ data[indextr].fullName }}
                </vs-td>
                <vs-td :data="data[indextr].departmentName">
                  {{ data[indextr].departmentName }}
                </vs-td>
                <vs-td :data="data[indextr].role">
                  {{ data[indextr].role }}
                </vs-td>
                <vs-td :data="data[indextr].procurementDeptId">
                  {{ data[indextr].procurementDeptId }}
                </vs-td>
                <vs-td :data="data[indextr].isVendorAdmin">
                  {{ data[indextr].isVendorAdmin }}
                </vs-td>
                <vs-td :data="data[indextr].isProjectAdmin">
                  {{ data[indextr].isProjectAdmin }}
                </vs-td>
                <vs-td :data="data[indextr].status">
                  {{ data[indextr].status }}
                </vs-td>
                <vs-td>
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editData(tr)"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="deleteData(tr.id)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pre v-if="data == null">No data Available.</pre>
        </div>
      </div>
    </vx-card>

    <!-- Pop Add -->
    <vs-popup classContent="popup" title="User" :active.sync="popup">
      <!-- Role and Status option -->
      <div class="vx-row mb-2">
        <div class="md:w-1/1 sm:w-1/4 w-full ml-4 mr-4">
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Role"
            v-model="model.role"
            :options="optionRole"
          />
        </div>
        <div class="md:w-1/1 sm:w-1/4 w-full ml-4 mr-4">
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Status"
            v-model="model.status"
            :options="optionStatus"
            label="label"
            :reduce="(optionStatus) => optionStatus.label"
          />
        </div>
      </div>

      <!-- User name -->
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label-placeholder="User name"
            v-model="model.userName"
          />
        </div>
      </div>

      <!-- Full name -->
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label-placeholder="Full name"
            v-model="model.fullName"
          />
        </div>
      </div>

      <!-- Department -->
      <div class="vx-row mt-2">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            label-placeholder="Department name"
            v-model="model.departmentName"
          />
        </div>
      </div>

      <!-- Procure Department -->
      <div class="vx-row mt-6">
        <div class="vx-col w-full">
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Procurement Department"
            v-model="model.procurementDeptId"
            :options="optionProcurementDept"
            label="departmentName"
            :reduce="(optionProcurementDept) => optionProcurementDept.id"
          />
        </div>
      </div>

      <vs-divider position="center">Permission</vs-divider>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 sm:w-1/2 w-full mb-2">
          <vs-checkbox class="inline-flex" v-model="model.isVendorAdmin"
            >Admin Vendor</vs-checkbox
          >
        </div>
        <div class="vx-col md:w-1/1 sm:w-1/2 w-full mb-2">
          <vs-checkbox class="inline-flex" v-model="model.isProjectAdmin"
            >Admin Project</vs-checkbox
          >
        </div>
      </div>
      <vs-divider />
      <div class="vx-row">
        <div class="vx-col md:w-1/1 sm:w-1/2 w-full"></div>
        <div class="vx-col md:w-1/1 sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click="submit">Submit</vs-button>
          <vs-button type="border" class="mb-2" @click="closePopup"
            >Cancel</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { _masterservices } from "../../services/masterservices";
export default {
  data() {
    return {
      data: [],
      selected: {},

      popup: false,

      optionRole: ["Admin", "User"],
      optionStatus: [
        { id: 1, label: "Active" },
        { id: 0, label: "Inactive" },
      ],
      optionProcurementDept: [],

      model: {
        id: 0,
        userName: "",
        fullName: "",
        departmentName: "",
        status: "",
        role: "",
        isActive: true,
        procurementDeptId: 0,
        isVendorAdmin: true,
        isProjectAdmin: true,
      },

      id: 0,
    };
  },
  components: {
    "v-select": vSelect,
  },
  created() {
    this.getUserMaster();
    this.getMasterProcurementDept();
  },
  methods: {
    async getUserMaster() {
      this.$vs.loading({
        type: "sound",
      });

      this.data = await _masterservices.GetMasterUsers();
      this.$vs.loading.close();
    },
    async getMasterProcurementDept() {
      this.optionProcurementDept = await _masterservices.GetMasterProcurementDept();
      // console.log(this.optionProcurementDept);
    },
    closePopup() {
      this.popup = false;
    },
    async AddNew() {
      this.popup = true;
      this.model = {};
    },
    async editData() {
      (this.model = {
        id: this.selected.id,
        userName: this.selected.userName,
        fullName: this.selected.fullName,
        departmentName: this.selected.departmentName,
        status: this.selected.status,
        role: this.selected.role,
        isActive: this.selected.isActive,
        procurementDeptId: this.selected.procurementDeptId,
        isVendorAdmin: this.selected.isVendorAdmin,
        isProjectAdmin: this.selected.isProjectAdmin,
      }),
        //   this.$router.push(`/vendor/main/${model.id}`).catch(() => {});
        (this.popup = true);
    },
    async submit() {
      this.$vs.loading({
        type: "sound",
      });

      if (this.model.id == undefined)
        await _masterservices.AddMasterUser(this.model);
      else await _masterservices.UpdateMasterUser(this.model);

      this.$vs.notify({
        title: "Add, Update Master User",
        text: "Add, Update Master User success",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });

      this.$vs.loading.close();

      this.popup = false;

      this.getUserMaster();
    },
    async deleteData(id) {
      this.id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm delete`,
        text: `Are you sure to delete this user?`,
        accept: this.acceptAlert,
      });
    },
    acceptAlert: async function() {
      await _masterservices.DeletetMasterUser(this.id);
      // Hide button approve
      this.getUserMaster();
    },
  },
};
</script>

<style lang="scss" scoped></style>
